import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Loader2, Award, Truck, XCircle, Clock } from "lucide-react";
import authService from "../../services/authService";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/desempenho-fornecedor`;

const corNota = (nota) => {
  if (nota === null || nota === undefined) return "text-gray-400";
  if (nota >= 80) return "text-green-400";
  if (nota >= 50) return "text-yellow-400";
  return "text-red-400";
};

const RankingFornecedores = () => {
  const [carregando, setCarregando] = useState(true);
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    const carregar = async () => {
      try {
        const resp = await authService.fetchAuth(`${API}/admin/ranking`);
        if (resp.ok) setRanking(await resp.json());
      } catch (error) {
        console.error("Erro ao carregar ranking:", error);
      } finally {
        setCarregando(false);
      }
    };
    carregar();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <Award className="w-7 h-7 text-yellow-400" />
        <div>
          <h1 className="text-2xl font-bold text-white">Desempenho dos Fornecedores</h1>
          <p className="text-sm text-gray-400">SLA de entrega e taxa de cancelamento, calculados com pedidos reais</p>
        </div>
      </div>

      {carregando ? (
        <div className="flex items-center justify-center py-16 text-gray-400">
          <Loader2 className="w-6 h-6 animate-spin mr-2" />
          Carregando...
        </div>
      ) : ranking.length === 0 ? (
        <Card className="p-8 text-center text-gray-400 bg-gray-800/50 border-gray-700">
          Nenhum fornecedor com pedidos suficientes para avaliar ainda.
        </Card>
      ) : (
        <div className="space-y-2">
          {ranking.map((f, idx) => (
            <Card key={f.fornecedor_id} className="p-4 bg-gray-800/50 border-gray-700">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-gray-500 text-sm">#{idx + 1}</span>
                  <p className="text-white font-medium">{f.nome}</p>
                  <span className="text-xs px-2 py-0.5 rounded bg-gray-700 text-gray-300">
                    {f.mercado === "internacional" ? "🌐 Internacional" : "🇧🇷 Brasil"}
                  </span>
                </div>
                <p className={`text-xl font-bold ${corNota(f.nota_desempenho)}`}>
                  {f.nota_desempenho ?? "—"}
                </p>
              </div>
              <div className="flex gap-4 text-xs text-gray-400">
                <span className="flex items-center gap-1"><Truck className="w-3 h-3" /> {f.total_pedidos} pedidos</span>
                {f.tempo_medio_entrega_dias !== null && (
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {f.tempo_medio_entrega_dias}d entrega média</span>
                )}
                <span className="flex items-center gap-1"><XCircle className="w-3 h-3" /> {f.taxa_cancelamento_percentual}% cancelamento</span>
              </div>
              {f.aviso && <p className="text-xs text-yellow-500 mt-1">{f.aviso}</p>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default RankingFornecedores;
